// utils/capitalize.js

/**
 * Capitalizes the first letter of a string and lowers the rest.
 * @param {string} str - The string to capitalize.
 * @returns {string}
 */
const capitalize = str => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export default capitalize;
